/**
 * pickup-availability.js
 *
 * Custom element pour le theme Horizon. Ecoute l'evenement
 * ThemeEvents.variantUpdate (deja emis par product-form-component
 * a chaque changement de variante) et met a jour son propre contenu
 * en re-demandant le rendu au serveur pour la nouvelle variante.
 *
 * Aucune modification des fichiers existants du theme n'est necessaire :
 * ce fichier s'auto-enregistre et s'auto-cable au chargement.
 */

import { ThemeEvents } from '@theme/events';

class PickupAvailabilityComponent extends HTMLElement {
  connectedCallback() {
    this.productUrl = this.dataset.productUrl;
    this._onVariantUpdate = this._onVariantUpdate.bind(this);
    document.addEventListener(ThemeEvents.variantUpdate, this._onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this._onVariantUpdate);
  }

  /**
   * @param {CustomEvent} event - VariantUpdateEvent emis par product-form-component
   */
  async _onVariantUpdate(event) {
    const variantId = event.detail?.resource?.id;
    if (!variantId || !this.productUrl) return;

    try {
      const response = await fetch(
        `${this.productUrl}?variant=${variantId}&section_id=pickup-availability`
      );
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newContent = doc.querySelector('.pickup-availability-wrapper');

      if (newContent) {
        this.innerHTML = newContent.outerHTML;
      }
    } catch (error) {
      console.error('[pickup-availability] Echec de la mise a jour :', error);
    }
  }
}

if (!customElements.get('pickup-availability-component')) {
  customElements.define('pickup-availability-component', PickupAvailabilityComponent);
}



